// Money helpers for the allocation split; everything compares in cents to avoid floating point surprises.
export const toCents = (value) => {
  const number = Number(String(value ?? '').replace(',', '.'));
  return Number.isFinite(number) ? Math.round(number * 100) : 0;
};
export const fromCents = (cents) => Math.round(cents) / 100;

export function sumLines(lines) {
  return fromCents((lines || []).reduce((total, line) => total + toCents(line.Bedrag), 0));
}

export function remainingAmount(lines, target) {
  return fromCents(toCents(target) - toCents(sumLines(lines)));
}

// spreads `target` over `count` rows, putting the rounding cents on the last row
export function splitEvenly(target, count) {
  const cents = toCents(target);
  const each = Math.floor(cents / count);
  return Array.from({ length: count }, (_, index) => fromCents(index === count - 1 ? cents - each * (count - 1) : each));
}

export function validateLines(lines, target, { requireCostType = true } = {}) {
  const errors = {};
  (lines || []).forEach((line, index) => {
    const rowErrors = [];
    if (toCents(line.Bedrag) <= 0) rowErrors.push('Amount must be greater than zero');
    if (requireCostType && !Number(line.FactuurTypeID)) rowErrors.push('Cost type is required');
    if (rowErrors.length) errors[index] = rowErrors;
  });
  const remaining = remainingAmount(lines, target);
  return { errors, remaining, isBalanced: toCents(remaining) === 0 && (lines || []).length > 0, hasRowErrors: Object.keys(errors).length > 0 };
}
